import { motion } from "framer-motion";
import { MapPin, Sparkles } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { CONTACT } from "@/data/content";

export const Hero = () => {
  return (
    <section id="accueil" className="relative overflow-hidden pt-28 pb-16 sm:pt-32 lg:pt-40 lg:pb-24">
      <div className="absolute -top-24 -right-24 h-[420px] w-[420px] rounded-full bg-pastelbg blur-0" />
      <div className="absolute top-40 -left-32 h-80 w-80 rounded-full bg-beige/60" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <span className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-xs font-semibold uppercase tracking-wider text-strawberry shadow-soft">
            <MapPin size={14} /> {CONTACT.zone}
          </span>

          <h1 className="mt-6 font-heading text-5xl sm:text-6xl lg:text-7xl font-light leading-[1.05] text-chocolate">
            La gourmandise qui fait <span className="italic text-strawberry">fondre</span> vos événements
          </h1>

          <p className="mt-6 text-base sm:text-lg text-cocoa max-w-xl leading-relaxed">
            Moum's installe son stand de <strong>glace à l'italienne</strong> pour sublimer vos mariages,
            anniversaires et fêtes. Une prestation clé en main, gourmande et 100% personnalisée.
          </p>

          <div className="mt-9 flex flex-wrap gap-4">
            <button
              data-testid="hero-devis-btn"
              onClick={() => scrollToId("devis")}
              className="inline-flex items-center gap-2 rounded-full bg-strawberry px-8 py-4 text-base font-semibold text-white shadow-hover hover:bg-[#B83044] hover:scale-105 transition-all"
            >
              <Sparkles size={18} /> Demander un devis gratuit
            </button>
            <button
              data-testid="hero-prestations-btn"
              onClick={() => scrollToId("prestations")}
              className="inline-flex items-center rounded-full bg-white px-8 py-4 text-base font-semibold text-chocolate border border-beige shadow-soft hover:bg-pastelbg transition-all"
            >
              Découvrir nos prestations
            </button>
          </div>

          <div className="mt-10 flex items-center gap-6 text-sm text-cocoa">
            <div><span className="font-heading text-3xl font-semibold text-chocolate">100%</span><br/>Personnalisé</div>
            <div className="h-10 w-px bg-beige" />
            <div><span className="font-heading text-3xl font-semibold text-chocolate">3</span><br/>Parfums signature</div>
            <div className="h-10 w-px bg-beige" />
            <div><span className="font-heading text-3xl font-semibold text-chocolate">Clé en main</span><br/>Installation incluse</div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="relative"
        >
          <div className="absolute inset-0 -m-6 rounded-[3rem] bg-pastel/40 rotate-6" />
          <img
            src="https://images.unsplash.com/photo-1636564499112-6113e73c504a"
            alt="Glace à l'italienne vanille onctueuse Moum's"
            className="relative rounded-[2.5rem] w-full h-[520px] object-cover shadow-hover"
          />
          <motion.div
            animate={{ y: [0, -14, 0] }}
            transition={{ duration: 6, repeat: Infinity }}
            className="absolute -bottom-6 -left-6 bg-white rounded-3xl px-6 py-4 shadow-hover border border-beige"
          >
            <p className="font-heading text-xl font-semibold text-chocolate">🍦 Vanille · Fraise · Chocolat</p>
            <p className="text-xs text-cocoa">+ toppings & coulis gourmands</p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
